export default __webpack_public_path__ + "static/media/TF_10.2a6d36ab.png";